import { useState } from "react";
import { useGetPropertyReportOutstanding } from "@/services";
import { formatAmount } from "@/lib/utils";

const useOccupantsDialog = ({ selectedRow }: {selectedRow: any}) => {
  const [activeTab, setActiveTab] = useState<string>(selectedRow?.selectedTab);

  const onTabChange = (tab: string) => {
    setActiveTab(tab);
  }

  const {
    data: documentList,
    isLoading: isDocLoading,
  } = useGetPropertyReportOutstanding({
    propertyId: selectedRow?.propertyId,
    queryParams: {
      enabled: !!selectedRow?.communityId,
    },
  });
  
  const columns = [
    {
      accessorKey: "ownerName",
      header: <div>Owner Account</div>,
      accessorFn: (row: any) => String(row?.ownerName || ""),
    },
    {
      accessorKey: "glMasterName",
      header: <div>Charge</div>,
      accessorFn: (row: any) => String(row?.glMasterName || ""),
    },
    {
      accessorKey: "balance",
      header: <div>Balance</div>,
      accessorFn: (row: any) => formatAmount(row?.balance || "0"),
    },
  ]

  return {
    activeTab,
    onTabChange,
    columns,
    documentList: documentList?.data || {},
    isDocLoading,
  }
}

export default useOccupantsDialog;